<!-- components/ShopCardGrid.vue -->
<template>
    <section
        class="flex justify-center items-center bg-[var(--background-primary)] border border-[var(--background-btn)] p-4 rounded-2xl ">
        <div class="grid grid-cols-2 gap-4 max-w-[380px] w-full">
            <!-- Individual Shop Card -->
            <div v-for="shop in shops" :key="shop.code"
                class="flex items-center gap-3 p-4 rounded-2xl bg-[var(--background-btn)] cursor-pointer hover:shadow-md transition-shadow">

                <!-- Image + Flag -->
                <div class="relative w-12 h-12 rounded-full ]">
                    <!-- Shop background image -->
                    <NuxtImg :src="shop.img" :alt="shop.name" width="48" height="48" loading="lazy" />

                    <!-- Flag overlay -->
                    <NuxtImg :src="shop.flag" :alt="shop.code + ' flag'" width="20" height="20"
                        class="absolute -top-1 -left-1" loading="lazy" />
                </div>

                <!-- Shop Name -->
                <h2 class="text-base font-semibold text-foreground">{{ shop.name }}</h2>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
const shops = [
    { name: "Shop.uk", code: "uk", img: "images/join-waitlist/shop.png", flag: "images/join-waitlist/uk-flag.png" },
    { name: "Shop.us", code: "us", img: "images/join-waitlist/shop.png", flag: "images/join-waitlist/us-flag.png" },
    { name: "Shop.in", code: "in", img: "images/join-waitlist/shop.png", flag: "images/join-waitlist/ind-flag.png" },
    { name: "Shop.au", code: "au", img: "images/join-waitlist/shop.png", flag: "images/join-waitlist/aus-flag.png" },
];
</script>
